import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      WHEN_YOU_DELETE_YOUR_ACCOUNT_THE_FOLLOWING_WILL_HAPPEN:
        "Når du sletter kontoen din, vil følgende skje",
      CANCEL: "Avbryt",
      DELETE_ACCOUNT: "Slett konto",
      YOUR_REQUEST_HAS_BEEN_RECEIVED:
        "Din forespørsel om å slette kontoen er mottatt og du vil motta en bekreftelse når slettingsprosessen er startet.",
      PLEASE_NOTE_THAT_OUTSTANDING_PAYMENTS_MUST_BE_PAID:
        "Vær oppmerksom på at alle utestående betalinger må betales før vi kan slette kontoen din.",
      DISCLAIMERS: [
        "Alle dine personlige data blir slettet",
        "Alle lagrede oppskrifter går tapt",
        "Rabatter går tapt",
        "Ordrehistorikk går tapt",
        "Kontoen kan ikke startes opp igjen",
      ],
    },

    se: {
      WHEN_YOU_DELETE_YOUR_ACCOUNT_THE_FOLLOWING_WILL_HAPPEN:
        "När du raderar ditt konto kommer följande att hända",
      CANCEL: "Avbryt",
      DELETE_ACCOUNT: "Radera konto",
      YOUR_REQUEST_HAS_BEEN_RECEIVED:
        "Din begäran om att radera ditt konto har mottagits och du kommer att få en bekräftelse när raderingsprocessen är påbörjad.",
      PLEASE_NOTE_THAT_OUTSTANDING_PAYMENTS_MUST_BE_PAID:
        "Vänligen notera att samtliga utestående betalningar behöver vara betalda innan vi kan radera ditt konto.",
      DISCLAIMERS: [
        "All din personliga data raderas",
        "Alla sparade recept förloras",
        "Rabatter och klubb-poäng förloras",
        "Orderhistorik förloras",
        "Inte möjligt att starta upp kontot igen",
      ],
    },

    dk: {
      WHEN_YOU_DELETE_YOUR_ACCOUNT_THE_FOLLOWING_WILL_HAPPEN:
        "Når du sletter din konto, sker følgende",
      CANCEL: "Annuller",
      DELETE_ACCOUNT: "Slet konto",
      YOUR_REQUEST_HAS_BEEN_RECEIVED:
        "Din anmodning om at slette kontoen er modtaget, og du vil modtage en bekræftelse, når sletningsprocessen er startet.",
      PLEASE_NOTE_THAT_OUTSTANDING_PAYMENTS_MUST_BE_PAID:
        "Bemærk venligst, at alle udestående betalinger skal betales, før vi kan slette din konto.",

      DISCLAIMERS: [
        "Alle dine personlige data vil blive slettet",
        "Alle gemte opskrifter går tabt",
        "Rabatter og klubpoint er tabt",
        "Ordrehistorik er tabt",
        "Kontoen kunne ikke genstartes",
      ],
    },
  } as const
)[language];
